import React, { Component } from "react";
import styled from "styled-components";
import { FaCocktail, FaHiking, FaShuttleVan, FaBeer } from "react-icons/fa";
import { Title } from "../UI/Title";
import { Span, Paragraph, H6 } from "../index";

type Service = {
  icon?: JSX.Element;
  title?: string;
  info?: string;
};

interface IServices {
  services?: Service[];
}

export default class Services extends Component<IServices> {
  state: IServices = {
    services: [
      {
        icon: <FaCocktail />,
        title: "free cocktail",
        info: "Lorem ipsum Harum nemo unde quae earum nulla laboriosam ab cumque sint, officiis asperiores!",
      },
      {
        icon: <FaHiking />,
        title: "All round hiking",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.  cumque sint, officiis asperiores!",
      },
      {
        icon: <FaShuttleVan />,
        title: "free shuttle",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.  asperiores!",
      },
      {
        icon: <FaBeer />,
        title: "free beer",
        info: "Harum nemo unde quae earum nulla laboriosam ab cumque sint, officiis asperiores!",
      },
    ],
  };
  render() {
    // destruring state
    const { services } = this.state;
    return (
      <ContainerService>
        <section className='services'>
          <Title title='Our Services' />
          <div className='services-center'>
            {services &&
              services.map((service, index) => {
                return (
                  <article key={index} className='service'>
                    <Span>{service.icon}</Span>
                    <H6>{service.title}</H6>
                    <Paragraph>{service.info}</Paragraph>
                  </article>
                );
              })}
          </div>
        </section>
      </ContainerService>
    );
  }
}
// container witn embedded styles
const ContainerService = styled.div`
  /* services */
  .services {
    padding: 5rem 0;
  }
  .services {
    background: var(--gray-3);
    text-align: center;
  }
  .services-center {
    width: 90vw;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));
    grid-row-gap: 2rem;
    grid-column-gap: 50px;
  }
  .services span {
    display: inline-block;
    color: var(--mainBlack);
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
  .services h6 {
    letter-spacing: var(--mainSpacing);
    text-transform: uppercase;
  }
  .services p {
    width: 80%;
    margin: 0 auto;
  }
  @media screen and (min-width: 992px) {
    .services-center {
      width: 95vw;
      max-width: 1170px;
    }
  }

  @media screen and (min-width: 1200px) {
    .services p {
      width: 100%;
    }
  }
`;
